export default __webpack_public_path__ + "static/media/motorcycle.6ae0d240.svg";